import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

// Interface to define the structure of a TechGeek object
interface TechGeek {
  image: string;
  title: string;
  route: string;
}

@Component({
  selector: 'app-relevant-techgeek',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './relevant-techgeek.component.html',
  styleUrl: './relevant-techgeek.component.scss'
})
export class RelevantTechgeekComponent implements OnInit {

  // This array will hold the 3 random TechGeek editions to be displayed
  relevantTechGeeks: TechGeek[] = [];

  // This is the master list of ALL available TechGeek editions.
  private allTechGeeks: TechGeek[] = [
    {
      title: 'Edition 1',
      image: 'assets/resources/techgeek/Tech Geek_1.webp',
      route: '/kalpita-tech-geek/techgeek-1'
    },
    {
      title: 'Edition 2',
      image: 'assets/resources/techgeek/Tech Geek_2.webp',
      route: '/kalpita-tech-geek/techgeek-2'
    },
    {
      title: 'Edition 3',
      image: 'assets/resources/techgeek/Tech Geek_3.webp',
      route: '/kalpita-tech-geek/techgeek-3'
    },
    {
      title: 'Edition 4',
      image: 'assets/resources/techgeek/Tech Geek_4.webp',
      route: '/kalpita-tech-geek/techgeek-4'
    },
    {
      title: 'Edition 5',
      image: 'assets/resources/techgeek/Tech Geek_5.webp',
      route: '/kalpita-tech-geek/techgeek-5'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Get the current active URL from the Angular Router.
    const currentUrl = this.router.url;
    
    // Pass the current URL to the selection method to ensure it's excluded.
    this.selectRandomTechGeeks(currentUrl);
  }

  /**
   * Selects 3 random TechGeek editions, excluding the one specified by the currentRoute.
   * @param currentRoute The route of the page currently being viewed.
   */
  private selectRandomTechGeeks(currentRoute: string): void {
    // Step 1: Filter the master list to create a new list that EXCLUDES the current page.
    const availableSelections = this.allTechGeeks.filter(techgeek => techgeek.route !== currentRoute);

    // Step 2: Shuffle the filtered list of available selections.
    const shuffled = [...availableSelections].sort(() => 0.5 - Math.random());

    // Step 3: Take the first 3 items from the shuffled list.
    this.relevantTechGeeks = shuffled.slice(0, 3);
  }

  // This method handles the navigation when a card is clicked.
  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }
}